import { observer } from "mobx-react";
import React, { Component } from "react";
import { InjectedIntl, injectIntl, IntlProvider } from "react-intl";
import { FLAGS } from "../../../shared/flags";
import { MainStore } from "../../../stores/MainStore";
import Image from "../../Image";
import Label from "../../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
  intl: IntlProvider & InjectedIntl;
}
interface IState {}
@observer
class CountryModalHeader extends Component<IProps, IState> {
  render() {
    const { store, intl } = this.props;
    const { selectedState } = store;
    return (
      <div className={classes.CountryModalHeader}>
        <div>
          <Image src={FLAGS[selectedState.flag]} alt={"Country Flag"} small />
        </div>
        <div>
          <Label
            className={classes.CountryModalTitle}
            medium
            bold
            text={intl.formatMessage({
              id: `${store.selectedState.id}-label`
            })}
          />
        </div>
      </div>
    );
  }
}
export default injectIntl(CountryModalHeader);
